export default __webpack_public_path__ + "static/media/step2.53b39bd3.png";